<template>
  <b-card :title="$t('card.companyModel.title')">
    <b-card-body>
      <b-table
        v-if="items.length"
        :stacked="stacked"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="localItems"
        :fields="fields"
      >
        <template slot="order" slot-scope="data">
          <b-input-group>
            <b-input-group-prepend>
              <b-btn :disabled="data.index === 0" @click="moveUp(data.index)" variant="warning">
                <i class="fas fa-arrow-up"></i>
              </b-btn>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <b-btn :disabled="data.index === items.length - 1" @click="moveDown(data.index)" variant="warning">
                <i class="fas fa-arrow-down"></i>
              </b-btn>
            </b-input-group-prepend>
          </b-input-group>
        </template>
        <template slot="actions" slot-scope="data">
          <button class="btn btn-danger" @click="setInfo(data.item)">{{$t('page.generic.remove')}}</button>
        </template>
        <template slot="categories" slot-scope="data">
          <b-badge v-for="category in data.item.model.categories" :key="category.id" :variant="`warning`" class="mx-1">
            {{category.code}}
          </b-badge>
        </template>
        <template slot="mandatory" slot-scope="data">
          <c-switch class="mx-1" v-model="data.item.mandatory" color="success" variant="pill" label/>
        </template>
        <template slot="model.description" slot-scope="data">
          <span>{{ data.item.model.description }}</span>
        </template>
      </b-table>
      <div class="jumbotron border-dark border" v-else>
        <h3>{{ $t('page.noModelAvailbale') }}</h3>
        <p class="lead">{{ $t('page.addModel') }}</p>
      </div>
    </b-card-body>
    <b-row>
      <b-col sm="12">
        <button class="btn btn-success float-right padder" type="button" @click="showModelList()">
          {{$t('actions.add')}}
        </button>
      </b-col>
    </b-row>
    <b-modal
      :title="$t('modal.removeCompanyModel.title')"
      class="modal-danger"
      v-model="deleteModal"
      @ok="deleteCompanyModel"
      ok-variant="danger"
      header-bg-variant="danger"
      :okTitle="$t('page.generic.remove')"
      :cancelTitle="$t('actions.abort')"
    >
      <div v-if="selectedCompanyModel" v-html="deleteModalText"></div>
    </b-modal>
  </b-card>
</template>

<script>
  import {Switch as cSwitch} from '@coreui/vue'
  import i18n from '@/config/i18n'

  export default {
    components: {
      cSwitch
    },
    data() {
      return {
        deleteModal: false,
        selectedCompanyModel: null,
        fields: [
          {
            key: 'order',
            sortable: false,
            label: 'Ordine'
          },
          {
            key: 'actions',
            sortable: false,
            label: ''
          },
          {
            key: 'mandatory',
            sortable: false,
            label: i18n.t('page.generic.mandatory')
          },
          {
            key: 'model.code',
            sortable: false,
            label: i18n.t('page.generic.code')
          },
          {
            key: 'model.modelVersion',
            sortable: false,
            label: i18n.t('page.generic.version'),
            formatter: 'versionFormatter'
          },
          {
            key: 'model.modelFormat',
            sortable: false,
            label: i18n.tc('page.generic.format', 1)
          },
          {
            key: 'model.description',
            sortable: false,
            label: i18n.t('page.generic.description')
          },
          {
            key: 'categories',
            sortable: false,
            label: i18n.tc('title.categories', 1)
          },
        ],
        localItems: [],
      }
    },
    methods: {
      setInfo(companyModel){
        this.deleteModal = true;
        this.selectedCompanyModel = companyModel;
      },
      deleteCompanyModel() {
        this.$emit('deleteCompanyModel', this.selectedCompanyModel);
      },
      showModelList() {
        this.$bvModal.show('model-list');
      },
      versionFormatter(value) {
        return `V-${value < 10 ? '0' + value : value}`
      },
      moveUp(index) {
        if (index > 0) {
          this.localItems.splice(index - 1, 0, this.localItems.splice(index, 1)[0]);
          this.updateOrderModel();
        }
      },
      moveDown(index) {
        if (index < this.items.length - 1) {
          this.localItems.splice(index + 1, 0, this.localItems.splice(index, 1)[0]);
          this.updateOrderModel();
        }
      },
      updateOrderModel() {
        this.localItems.forEach((item, index) => {
          item.orderModel = index + 1;
        });
        this.$emit('update:tableData', this.localItems);
      },
    },
    watch: {
      tableData: {
        immediate: true,
        handler(newData) {
          this.localItems = [...newData].sort((a, b) => a.orderModel - b.orderModel);
        },
      },
    },
    computed: {
      items: function () {
        if (!Array.isArray(this.tableData)) {
          return [];
        }
        const sorted = [...this.tableData].sort((a, b) => a.orderModel - b.orderModel);
        return sorted;
      },
      deleteModalText: function(){
        return i18n.t('modal.removeCompanyModel.text', {code: this.selectedCompanyModel.model.code, desc: this.selectedCompanyModel.model.description})
      },
    },
    props:
        {
          stacked: {
            type: String,
            default: 'sm'
          },
          hover: {
            type: Boolean,
            default: true
          },
          striped: {
            type: Boolean,
            default: false
          },
          bordered: {
            type: Boolean,
            default: false
          },
          small: {
            type: Boolean,
            default: false
          },
          fixed: {
            type: Boolean,
            default: false
          },
          perPage: {
            type: Number,
            default: 7
          },
          tableData: {
            default: []
          }
        }
  }
</script>
